import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const PositiveId = z.coerce.number().int().positive();
export const postTeamsInterestFormRoute = {
    version: 1,
    method: 'POST',
    path: '/learner/post-teams-interest-form',
    name: 'post-teams-interest-form',
    request: {
        // This public acquisition endpoint may have callers outside the current
        // frontend; only the contact address is required to process a lead.
        body: z.object({
            workEmail: z.string(),
            company: z.string().optional(),
            teamSize: z.string().optional(),
            extraInfo: z.string().optional(),
        }),
    },
    responses: { 200: z.object({}), 400: HttpErrorResponse },
};
export const submitCohortFeedbackRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/cohorts/{cohortId}/learners/{learnerId}/feedback',
    name: 'submit-cohort-feedback',
    request: {
        params: z.object({
            cohortId: PositiveId,
            learnerId: PositiveId,
        }),
        // The survey is a map of question slug to the answer given. The answer is
        // a scalar for single-choice and free-text questions, and a map of option
        // to score for the ranked questions.
        body: z.object({
            survey: z.record(z.object({
                question: z.string(),
                answer: z.union([z.string(), z.number(), z.record(z.number())]),
            })),
        }),
    },
    responses: {
        200: z.string(),
        400: HttpErrorResponse,
    },
};
export const createTeamsAIReviewRoute = {
    version: 1,
    method: 'POST',
    path: '/learner/aireview',
    name: 'create-teams-ai-review',
    request: {
        body: z.object({
            submissionId: PositiveId,
            activitySlug: z.string().min(1),
            questionSlugToAnswer: z.record(z.unknown()).optional(),
        }),
    },
    responses: {
        200: z.string(),
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
